import { BpLink } from '../../../../shared/components/text/link/BpLink'
import React from 'react'

interface CompetitorAdsCountCellProps {
  ads_count: string
  project_id: number | string
  domain: string
}

export const CompetitorAdsCountCell = ({
  ads_count,
  project_id,
  domain,
}: CompetitorAdsCountCellProps) => {
  return <BpLink to={`ads-domain/${project_id}/${domain}`}>{ads_count}</BpLink>
}
